
//管理所有的可以选中的三维对象
export class AnimationManager {
  constructor(sceneManager) {
    this.sceneManager = sceneManager;
    this.animationStack = new Object();
  }

  addAnimationTarget(name, target){
    this.animationStack[name] = target;
  }

  removeAnimationTarget(name){
    delete this.animationStack[name];
  }

  moveAFrame(delta){
      for(var animationTarget in this.animationStack){
        this.animationStack[animationTarget].moveAFrame(delta);
      }
  }



}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/AnimationManager.js